var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9411 4.23732C16.9719 3.23227 15.1893 3.13126 14.1616 4.19691C13.6648 4.71207 13.2849 5.56055 13.0511 6.40398C13.0122 7.02015 12.9976 7.5454 13.0024 8.01005C13.0024 8.39388 13.0073 8.49489 13.0024 8.86863C14.0155 8.97974 16.5335 9.0959 17.5563 8.0353C18.584 6.96964 18.9103 5.24742 17.9411 4.24237V4.23732Z",
    stroke: "black",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05889 4.23732C9.02811 3.23227 10.8107 3.13126 11.8384 4.19691C12.3352 4.71207 12.7151 5.56055 12.9489 6.40398C12.9878 7.02015 13.0024 7.5454 12.9976 8.01005C12.9976 8.39388 12.9927 8.49489 12.9976 8.86863C11.9845 8.97974 9.46646 9.0959 8.44366 8.0353C7.42085 6.97469 7.08966 5.24742 8.05889 4.24237V4.23732Z",
    stroke: "black",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7337 9.25244H3.2712C2.80585 9.25244 2.4286 9.64363 2.4286 10.1262V14.0555C2.4286 14.538 2.80585 14.9292 3.2712 14.9292H22.7337C23.199 14.9292 23.5763 14.538 23.5763 14.0555V10.1262C23.5763 9.64363 23.199 9.25244 22.7337 9.25244Z",
    stroke: "black",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4074 15.0657H3.59265V26.5556H22.4074V15.0657Z",
    stroke: "black",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9976 9.24243V15.5909",
    stroke: "black",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9976 15.5908V26.5555",
    stroke: "black",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGift);
export default __webpack_public_path__ + "static/media/icon-gift.4eea907692f443c005d678f395098f3e.svg";
export { ForwardRef as ReactComponent };